export default function parseXML (xmlStr) {
  return toDOM(clean(xmlStr))
}

function clean (xmlStr) {
  if (Array.isArray(xmlStr)) xmlStr = xmlStr.join('\n')
  if (typeof xmlStr !== 'string') throw new Error(`xml/parse cannot parse invalid xml (${typeof xmlStr}): ${xmlStr}`)

  // clean out CDATA garbage
  xmlStr = xmlStr.trim()
  xmlStr = xmlStr
    .replace(/^<\?xml version="1\.0" encoding="UTF-8"\?>/, '')
    // replace \c & \code with <code> block
    .replace(/(\\c(ode)?) (.+)$/gm, '<code class="codeblock">$3</code>')

  if (!process.browser) {
    // make CDATA actual comments because jsdom doesn't understand CDATA
    xmlStr = xmlStr
      .replace(new RegExp('<!\\[CDATA\\[', 'g'), '<!--\n')
      .replace(new RegExp(']]>', 'g'), '\n-->')
  }

  return xmlStr
}

function toDOM (xmlStr) {
  if (!process.browser) {
    const { JSDOM } = require('jsdom')
    const dom = new JSDOM(xmlStr)
    return dom.window.document.body.children[0]
  } else if (typeof window.DOMParser !== 'undefined') {
    const parser = new window.DOMParser()
    const xml = parser.parseFromString(xmlStr, 'text/xml')
    return xml.children[0]
  } else {
    throw new Error('unknown xml parser environment')
  }
}



// WEBPACK FOOTER //
// ../webmango-utils/xml.js